import { useState, useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import request from '../../../lib/request';

const InstructionPopup = ({
  dialogRef,
  closeDialog,
  challenge,
  instructionOpen,
}) => {
  const carouselRef = useRef(null);
  const itemRefs = useRef([]);

  const [activeTab, setActiveTab] = useState(0);
  const [instructions, setInstructions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (instructionOpen) {
      getInstruction();
    }
  }, [instructionOpen]);

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollTo({
        left: 0,
      });
    }
    setCurrentIndex(0);
  }, [activeTab]);

  const getInstruction = async () => {
    try {
      const { result } = await request.get(
        `/challenge/${challenge.id}/instruction`
      );
      if (result) {
        setInstructions(result);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addToRefs = (el) => {
    if (el && !itemRefs.current.includes(el)) {
      itemRefs.current.push(el);
    }
  };

  const handleScroll = () => {
    itemRefs.current.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const containerRect = carouselRef.current.getBoundingClientRect();

      // Check if item is fully or partially visible
      if (
        rect.left >= containerRect.left &&
        rect.right <= containerRect.right
      ) {
        setCurrentIndex(index);
      }
    });
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
    >
      <div className='bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl p-4 pb-6 max-h-[95%] flex flex-col text-white border-t border-tertiary'>
        <button
          className='text-2xl flex items-center justify-end'
          onClick={closeDialog}
        >
          🅧
        </button>

        <div className='flex-shrink-0'>
          <h1 className='text-lg font-bold'>Instruction</h1>
          <div className='mt-4'>
            <div className='flex gap-4 border-b border-tertiary overflow-x-auto scrollbar-hidden'>
              {instructions.map((item, index) => (
                <button
                  key={index}
                  className={`flex-shrink-0 pb-2 px-2 text-sm ${
                    activeTab === index
                      ? 'border-b-2 border-white font-semibold'
                      : 'text-gray-400'
                  }`}
                  onClick={() => {
                    itemRefs.current = [];
                    setActiveTab(index);
                  }}
                >
                  {item.title}
                </button>
              ))}
            </div>
            <p className='my-4 whitespace-pre-line'>
              {instructions[activeTab]?.description}
            </p>
          </div>
        </div>

        <div className='flex-1 overflow-y-auto rounded-xl'>
          {instructions.length > 0 ? (
            <div
              ref={carouselRef}
              className='relative flex items-center justify-start gap-4 overflow-x-auto scrollbar-hidden snap-mandatory snap-x rounded-xl'
              onScroll={handleScroll}
            >
              {instructions[activeTab]?.steps?.map((step, i) => (
                <div
                  key={i}
                  ref={addToRefs}
                  className='relative flex-shrink-0 w-full snap-always snap-center bg-tertiary rounded-xl'
                >
                  {step.type === 'IMAGE' ? (
                    <div className='w-full h-full'>
                      <img
                        src={step.url}
                        alt={step.description}
                        className='w-full h-full object-cover rounded-t-xl'
                      />
                      <p className='mt-2 text-sm px-2 pb-2 whitespace-pre-line'>
                        {step.description}
                      </p>
                    </div>
                  ) : (
                    <div className='w-full h-full'>
                      <ReactPlayer
                        key={i}
                        url={step.url}
                        width='100%'
                        controls
                        playsinline={true}
                        muted={true}
                        config={{
                          attributes: {
                            controlsList: 'nodownload',
                          },
                        }}
                      />
                      <p className='mt-2 text-sm px-2 pb-2 whitespace-pre-line'>
                        {step.description}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : null}
        </div>
        <div className='flex items-center justify-center gap-2 mt-4'>
          {instructions[activeTab]?.steps?.map((_, i) => (
            <div
              key={i}
              className={`w-[6px] h-[6px] rounded-full ${
                i === currentIndex ? 'bg-accent' : 'bg-white/50'
              }`}
            ></div>
          ))}
        </div>
      </div>
    </dialog>
  );
};

export default InstructionPopup;
